import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import Hero from '@/components/Hero';
import FareHarborCalendar from '@/components/FareHarborCalendar';
const Booking = () => {
  const [itemId, setItemId] = useState<number | undefined>(undefined);
  const location = useLocation();
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const itemIdParam = queryParams.get('itemId');
    if (itemIdParam && !isNaN(Number(itemIdParam))) {
      setItemId(Number(itemIdParam));
    }
  }, [location.search]);

  // Function to scroll to booking calendar
  const scrollToCalendar = () => {
    const element = document.getElementById('booking-calendar');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen pt-20">
      <Helmet>
        <title>Book Your Cat History Tour | Cats About Town</title>
        <meta name="description" content="Reserve your spot on a unique NYC cat history walking tour. Browse available dates, select your preferred time, and complete your booking online." />
        <link rel="canonical" href="https://catsabouttowntours.com/booking" />
      </Helmet>
      
      <Hero title="Book Your Historical Cat Tour" subtitle="Select your preferred date and tour to start your historical feline tale adventure" backgroundImage="/lovable-uploads/93adf40c-ae90-4c69-8b73-4748c9db8a0e.png" height="medium" overlay={false} overlayOpacity="medium" contentPosition="center" imageStyle="darken" buttonText="View Calendar" buttonLink="#booking-calendar" onButtonClick={scrollToCalendar} imagePosition="center">
        
      </Hero>
      
      <section className="py-12" id="booking-calendar" aria-labelledby="booking-header">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h1 id="booking-header" className="text-3xl md:text-4xl font-bold mb-8 text-center">Available Tours Calendar</h1>
            <p className="text-center text-lg mb-8">Our unique walking tours explore the fascinating stories of cats from New York City's past—primarily the 1800s and early 1900s. While we occasionally spot modern felines along our routes (and you're welcome to bring your own cat companion!), our tours focus on bringing historical cat tales to life at iconic NYC locations.</p>
            
            <div className="border border-gray-200 rounded-lg shadow-sm p-6 bg-white">
              <div aria-live="polite">
                <FareHarborCalendar itemId={itemId} flowId={1219724} className="min-h-[700px]" />
              </div>
            </div>
            
            <div className="mt-12 text-center">
              <p className="mb-4">
                Need assistance with booking? Want to bring your cat along? Have other special requests or questions?
              </p>
              <a href="mailto:catsabouttowntour@gmail.com" className="btn-outline-gold inline-flex items-center" aria-label="Contact us via email for booking assistance">
                Contact Us
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-2" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
              </a>
            </div>
            
            <div className="mt-12 p-6 bg-[#F5EDE0] rounded-lg">
              
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default Booking;